// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.enumDIV {
    border: 1px solid lightgray;
    border-radius: 3px;
    padding: 2px;
    margin-bottom: 3px;
}`, "",{"version":3,"sources":["webpack://./src/app/workflow/modules/objectoperations/replaceenum/replaceenum.settings.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB","sourcesContent":[".enumDIV {\n    border: 1px solid lightgray;\n    border-radius: 3px;\n    padding: 2px;\n    margin-bottom: 3px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
